<template>
  <div class="survey-welcome-step">
    <div class="survey-welcome-step__meta">
      <a-tag class="survey-welcome-step__meta-item">
        <ProfileOutlined class="survey-welcome-step__meta-icon" />
        {{ questionsLabel }}
      </a-tag>
      <a-tag class="survey-welcome-step__meta-item">
        <ClockCircleOutlined class="survey-welcome-step__meta-icon" />
        {{ duration }}
      </a-tag>
      <a-tag v-if="validUntil" class="survey-welcome-step__meta-item">
        <CalendarOutlined class="survey-welcome-step__meta-icon" />
        Завершить до: {{ validUntil }}
      </a-tag>
    </div>

    <div class="survey-welcome-step__greeting">
      <p class="survey-welcome-step__greeting-line">{{ greetingHello }}</p>
      <p class="survey-welcome-step__greeting-line">{{ greetingText }}</p>
    </div>

    <a-alert
        type="info"
        show-icon
        class="blue-alert survey-welcome-step__alert"
    >
      <template #message>
        <span class="survey-welcome-step__alert-bold">Ваши ответы анонимны. </span>
        <span v-if="anonymityTail" class="survey-welcome-step__alert-text"> {{ anonymityTail }}</span>
      </template>
    </a-alert>
  </div>
</template>

<script>
import { computed } from 'vue';
import { CalendarOutlined, ClockCircleOutlined, ProfileOutlined } from '@ant-design/icons-vue';

export default {
  name: 'SurveyWelcomeStep',
  components: { CalendarOutlined, ClockCircleOutlined, ProfileOutlined},
  props: {
    greeting: {
      type: String,
      required: true,
    },
    anonymityNote: {
      type: String,
      required: true,
    },
    questionsLabel: {
      type: String,
      default: '',
    },
    duration: {
      type: String,
      default: '',
    },
    validUntil: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const greetingHello = computed(() => {
      const match = props.greeting.match(/^(Здравствуйте!)\s*/i);

      return match ? match[1] : 'Здравствуйте!';
    });

    const greetingText = computed(() => {
      return props.greeting.replace(/^Здравствуйте!\s*/i, '').trim();
    });

    const anonymityTail = computed(() => {
      return props.anonymityNote.replace(/^Ваши ответы анонимны\.\s*/i, '').trim();
    });

    return {
      greetingHello,
      greetingText,
      anonymityTail,
    };
  },
};
</script>

<style scoped lang="scss">
.blue-alert.ant-alert {
  padding: 8px 12px;
  font-weight: 400;
  background-color: var(--geek-blue-1);
  border: none;
  border-radius: 4px;
}

.blue-alert .ant-alert-message {
  padding: 0;
  margin: 0;
}

.survey-welcome-step {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  &__meta-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    margin: 0;
    color: var(--main-font);
    background: var(--light-grey);
    border: 1px solid var(--border-grey);
    border-radius: 4px;

    font-weight: 400;
    font-size: 12px;
    line-height: 110%;
  }

  &__meta-icon {
    font-size: 12px;
  }

  &__greeting, p {
    display: flex;
    flex-direction: column;
    gap: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    color: rgba(0, 0, 0, 0.88);
    font-family: "Open Sans", sans-serif;
  }

  &__greeting-line {
    margin: 0;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    color: var(--main-font);
  }

  &__alert {
    align-items: flex-start;
    margin: 0;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 120%;
    color: rgba(0, 0, 0, 0.88);

    :deep(.ant-alert-icon) {
      align-self: flex-start;
      display: flex;
      align-items: flex-start;
      margin-top: 0;
      color: var(--geek-blue-6, #2f54eb);
    }
  }

  &__alert-bold {
    font-weight: 600;
  }

  &__alert-text {
    font-weight: 400;
  }
}
</style>
